import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useSelectedApplication } from "@/hooks/use-selected-application";
import { AuthorityRequired } from "@/lib/auth";
import {
  createFileRoute,
  Link,
  Outlet,
  redirect,
  useLocation,
} from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/_main-layout/_settings/settings")({
  component: () => <SettingsLayoutComponent />,
  beforeLoad: ({ location }) => {
    if (location.pathname === "/settings") {
      throw redirect({ to: "/settings/account-settings" });
    }
  },
});

const SettingsLayoutComponent = () => {
  const context = Route.useRouteContext();
  const location = useLocation();
  const application = useSelectedApplication();
  const pathname = location.pathname;

  const canSeeNotificationsTab = application.hasVirtualAccountsEnabled;

  return (
    <div>
      <Tabs value={pathname.split("/").at(-1)}>
        <TabsList>
          <Link to={`/settings/account-settings`} search>
            <TabsTrigger value="account-settings">Account Settings</TabsTrigger>
          </Link>
          <AuthorityRequired
            authoritiesRequired={["EDIT_SETTINGS"]}
            authAuthorities={context.authorities}
          >
            {canSeeNotificationsTab && (
              <Link
                to={`/settings/notifications`}
                search
                key={application.applicationId}
              >
                <TabsTrigger value="notifications">Notifications</TabsTrigger>
              </Link>
            )}
          </AuthorityRequired>
          <AuthorityRequired
            authoritiesRequired={["EDIT_SETTINGS"]}
            authAuthorities={context.authorities}
          >
            <Link to={`/settings/webhooks-callbacks`} search>
              <TabsTrigger value="webhooks-callbacks">
                Webhooks and Callbacks
              </TabsTrigger>
            </Link>
          </AuthorityRequired>
          <AuthorityRequired
            authoritiesRequired={["EDIT_SETTINGS"]}
            authAuthorities={context.authorities}
          >
            <Link to={`/settings/accounts`} search>
              <TabsTrigger value="accounts">Accounts</TabsTrigger>
            </Link>
          </AuthorityRequired>
          <Link to={`/settings/institutions`} search>
            <TabsTrigger value="institutions">Institutions</TabsTrigger>
          </Link>
          <AuthorityRequired
            authoritiesRequired={["EDIT_SETTINGS"]}
            authAuthorities={context.authorities}
          >
            <Link to={`/settings/security`} search>
              <TabsTrigger value="security">Security</TabsTrigger>
            </Link>
          </AuthorityRequired>
          <AuthorityRequired
            authoritiesRequired={["ACCOUNT_ADMIN"]}
            authAuthorities={context.authorities}
          >
            <Link to={`/settings/users`} search>
              <TabsTrigger value="users">Users</TabsTrigger>
            </Link>
          </AuthorityRequired>
        </TabsList>
      </Tabs>
      <div className="mt-2">
        <Outlet />
      </div>
    </div>
  );
};
